<mat-chip-option
  class="clickable"
  data-test="chip-dropdown-chip-option"
  [matMenuTriggerFor]="menu"
  >
  {{ chipTitle }}
  <i class="far fa-angle-down ms-2"></i>
</mat-chip-option>

<mat-menu #menu="matMenu"
  xPosition="after"
  class="iris-chip-dropdown-menu"
  >
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

  @if (headerTemplate) {
    <mat-divider></mat-divider>
  }

  @for (option of options; track option) {
    <div mat-menu-item clickStopPropagation>
      <div class="flex-grow-1">{{ option.label }}</div>
      <i class="far fa-times" clickStopPropagation
         data-test="chip-dropdown-chip-option-remove"
         (click)="removeItem(option.value);"></i>
    </div>
  }

</mat-menu>


